export default __webpack_public_path__ + "static/recognisable-dark-8157bba2d9eb6e6912568f49a6e0381e.png";